import STRINGS_EN from "./strings"
import azureTables from "./azureTables"
import tableActions from "./tableActions"
export { tableActions , azureTables , STRINGS_EN }